import { render, staticRenderFns } from "./bottombar.vue?vue&type=template&id=5b56c4bb&"
import script from "./bottombar.vue?vue&type=script&lang=ts&"
export * from "./bottombar.vue?vue&type=script&lang=ts&"
import style0 from "./bottombar.vue?vue&type=style&index=0&id=5b56c4bb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports